import { useState } from "react";
import Button from "components/button";
import SideDrawer from "components/drawer";
import ManageStaffForm from "./manage-staff-form";

const FORM_ID = "manage-staff-form";

const ManageStaffDrawer = ({ isOpen, onClose, user, getStaffList }) => {
  const [saving, setSaving] = useState(false);
  const name = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();

  return (
    <SideDrawer
      isOpen={isOpen}
      onClose={onClose}
      size="lg"
      title="Manage Staff"
      subtitle={name || undefined}
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <Button type="submit" form={FORM_ID} loading={saving}>
            {saving ? "Saving…" : user?.id ? "Save Changes" : "Create Staff"}
          </Button>
        </>
      }
    >
      <ManageStaffForm
        formId={FORM_ID}
        user={user}
        onClose={onClose}
        onSavingChange={setSaving}
        getStaffList={getStaffList}
      />
    </SideDrawer>
  );
};

export default ManageStaffDrawer;
